import { useSelector } from 'react-redux';
import { Alert, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { selectSelectedLanguage } from '../../pages/store/language/selectors';
import leng from '../../constants/leng';

const FILE_MAX_SIZE = 102400; // 100 MB
const MB_SIZE = 1024; // 1 MB

interface FileDetailProps {
  file: File;
  sizeLimit?: (value: boolean) => void;
  onDelete: (id: string) => void;
}

const FileDetail = ({ file, sizeLimit, onDelete }: FileDetailProps) => {
  const selectLanguage = useSelector(selectSelectedLanguage);
  const isValidFileSize = file.size / MB_SIZE > FILE_MAX_SIZE;
  sizeLimit?.(isValidFileSize);
  return (
    <div
      className={`rounded relative p-3 text-primary-text text-left ${
        isValidFileSize ? 'bg-red-50' : 'bg-slate-50'
      }`}
    >
      <div className="absolute top-0 right-0">
        <IconButton
          onClick={() => onDelete(file.name)}
          size="small"
          aria-label="delete"
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Typography className="pr-3">{file.name}</Typography>
      {isValidFileSize && (
        <Alert severity="warning" className="my-3">
          {leng[selectLanguage.language].uploadInvoiceFileSizeExceeded}
        </Alert>
      )}
    </div>
  );
};

export default FileDetail;
